<script setup lang="ts">
import { APP_NAME, getPageTitle } from "@/assets/js/appConfig";
import { useDefaultStore } from "@/store";

definePage({
	name: "PeopleLeaderboard",
});

const store = useDefaultStore();

useHead({
	title: getPageTitle("People - Leaderboard"),
	meta: [
		{ name: "title", content: getPageTitle("People - Leaderboard") },
		{
			name: "description",
			content: `See the top People scores and compare your results with other ${APP_NAME} players.`,
		},
		{ name: "robots", content: "index, follow" },
		{ property: "og:title", content: getPageTitle("People - Leaderboard") },
		{
			property: "og:description",
			content: `See the top People scores and compare your results with other ${APP_NAME} players.`,
		},
		{ property: "og:site_name", content: APP_NAME },
	],
});
</script>

<template>
	<LeaderboardComp
		route-name="PeoplePage"
		category-name="People"
		:category-code="store.MAIN_CATEGORIES.PEOPLE"
	/>
</template>
